<template>
	<div class="color-field color-field--var">
		<label class="color-field__label">Var</label>
		<span class="color-field__meta editable-text">
			<input class="editable-text__input"
			 	type="text"	
				size="1"
				v-model="swatch.name"
				@keyup.enter="save($event)">
		</span>
	</div>
</template>

<script>
	import IconPencil        from "../../../../../Lib/Icons/IconPencil";
	import {rgbCSS}          from "../../../../../Lib/helpers/cssOutput";
	import DraftSwatch       from "../../../Store/DraftSwatch";
	import UsesActivePalette from "../Palette/UsesActivePalette";

	export default {
		name: 'hsb-fields',
		extends: UsesActivePalette,
		components: {
			IconPencil,
		},
		computed: {
			color() {
				return new DraftSwatch().rgb();
			},
			swatch() {
				return this.activeSwatch
			},
		},

		methods: {
			labelInputStyle() {
				let inputWidth;
				if(this.swatch.name.length <= 16) {
					inputWidth = 15;
				}
				else {
					inputWidth = this.swatch.name.length * 0.75;
				}
				return 'width: ' + inputWidth + 'em; max-width: 100%; ' +
					'color: ' + rgbCSS(this.color) + ';';
			},

			save($event) {
				$event.target.blur();
				this.$emit('watchForChanges')
			}
		}
	}
</script>